import React, { useState, useRef, useEffect } from 'react';

const ResizableBlock = ({ children, initialHeight = 200 }) => {
  const [height, setHeight] = useState(initialHeight);
  const [startY, setStartY] = useState(0);
  const [isResizing, setIsResizing] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    const handleMouseMove = (e) => {
      if (isResizing) {
        const deltaY = e.clientY - startY;
        setHeight((prevHeight) => Math.max(100, prevHeight + deltaY));
        setStartY(e.clientY);
      }
    };

    const handleMouseUp = () => {
      setIsResizing(false);
    };

    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);

    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    };
  }, [isResizing, startY]);

  const startResize = (e) => {
    e.preventDefault();
    setIsResizing(true);
    setStartY(e.clientY);
  };

  return (
    <div
      ref={containerRef}
      style={{
        width: '100%',
        minHeight: '100px',
        height: `${height}px`,
        position: 'relative',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <div style={{ flex: 1, overflow: 'hidden' }}>
        {children}
      </div>
      <div
        title="Drag to resize"
        style={{
          flexShrink: 0,
          width: '100%',
          height: '10px',
          cursor: 'ns-resize',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: 'rgba(0,0,0,0.04)',
          userSelect: 'none',
        }}
        onMouseDown={startResize}
      >
        <div style={{
          width: 32,
          height: 4,
          borderRadius: 2,
          background: 'rgba(0,0,0,0.25)',
        }} />
      </div>
    </div>
  );
};

export default ResizableBlock;
